import React from "react";
import { Link, Outlet } from "react-router-dom";
import { FaFacebook, FaInstagram, FaComments } from "react-icons/fa";

export default function SiteLayout({ children }) {
  // Use children if provided (for direct usage), else use <Outlet /> for nested routes
  return (
    <div className="site-layout">
      <header className="header">
        <div className="container">
          <Link className="brand" to="/" aria-label="Rental Highway Home">
            <img
              src="/assets/logo/LogoH.png"
              alt="Rental Highway"
              className="brand-logo"
            />
          </Link>
          <nav className="nav-links" aria-label="Main Navigation">
            <a href="/#why-us">Why Us</a>
            <a href="/#coverage">All Nepal Coverage</a>
            <a href="/#for-everyone">For Renters & Owners</a>
            <Link to="/blog">Blogs</Link>
          </nav>
          <div className="header-actions">
            <Link className="btn btn-primary btn-nav" to="/app/login">
              Find Rental
            </Link>
          </div>
        </div>
      </header>
      <main>{children || <Outlet />}</main>
      <footer className="footer">
        <div className="container">
          <div className="social-links">
            <a
              href="https://www.facebook.com/profile.php?id=61583854052645"
              aria-label="Facebook"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/rental.highway/"
              aria-label="Instagram"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="mailto:support@rentalhighway.com"
              aria-label="Email support"
            >
              <FaComments />
            </a>
          </div>
          <div className="footer-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/data-deletion">Delete Account / Data</Link>
            <a href="mailto:support@rentalhighway.com">Contact Us</a>
          </div>
          <div className="footer-copyright">
            &copy; {new Date().getFullYear()} Rental Highway. Built for Nepal.
            Every province. Every renter. Every owner.
          </div>
        </div>
      </footer>
    </div>
  );
}
